module.exports = "<h2>Page Not found</h2>\n\n<!--contact-->\n<app-contact></app-contact>"